/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//register global variable
window.AB = {
  login: {
  	timer: null
  },
  site: {
  	parkingInfo: {
  		timer: null
  	}
  },
  TOKEN: window.localStorage.getItem('appBackToken'),
  client: {
  	timer: null
  },
  BTNLIST:{},
  MENULIST: [],
  componentHub: {
    menus: null
  },
  headerLayout: {}
}

require('font-awesome-sass-loader');
require('bootstrap-loader')
require('nprogress');

require('src/common/common.js');
require('appUtil/ajaxSetting');

require('scssDir/common/reset.css');
require('scssDir/common/main.scss');
require('scssDir/common/common.scss');
require('scssDir/common/btn.scss');
require('scssDir/common/box.scss');
require('scssDir/common/article.scss');
require('scssDir/common/transition.scss');





// WEBPACK FOOTER //
// ./src/appBackend/common.js